import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import bp from 'styled-components-breakpoint';
import { Container } from 'components/Grid';
import { SecondaryIcon } from '../../../Button/button.styled';
import MobileSeriesOptions from '../MobileSeriesOptions';

const Footer = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.grayscale.white};
  border-top: 1px solid ${(props) => props.theme.colors.grayscale.gray3};
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  height: 7.1875rem;
  left: 0;
  min-width: 21.5rem;
  padding: 1rem 0;
  position: fixed;
  width: 90vw;
  ${bp('tablet')`
    width: 75vw;
  `}

  &.no-book-bike-btn {
    height: auto;
  }
`;

const StyledSecondaryButton = styled(SecondaryIcon)`
  ${(props) => props.theme.borders.borderBlue1};
  color: ${(props) => props.theme.colors.blue.primary};
  width: 100%;
`;

function PaneFooter({
  activeState,
  activeRegion,
  id,
  regionClick,
  studiosClick,
  showBookBikeButton,
}) {
  function renderFooterContent() {
    if (activeState === 'studios') {
      return (
        <Container width={1} px="1rem">
          <StyledSecondaryButton
            id="header-studios-buy-series-button"
            href="/series"
            variation="secondary"
            as="a"
          >
            Buy Series
          </StyledSecondaryButton>
        </Container>
      );
    }
    return (
      <MobileSeriesOptions
        activeState={activeState}
        activeRegion={activeRegion}
        regionClick={regionClick}
        studiosClick={studiosClick}
        showBookBikeButton={showBookBikeButton}
      />
    );
  }

  return (
    <Footer id={id} className={!showBookBikeButton ? 'no-book-bike-btn' : ''}>
      {renderFooterContent()}
    </Footer>
  );
}

PaneFooter.propTypes = {
  activeState: PropTypes.string.isRequired,
  activeRegion: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  id: PropTypes.string,
  regionClick: PropTypes.func.isRequired,
  studiosClick: PropTypes.func.isRequired,
  showBookBikeButton: PropTypes.bool,
};

PaneFooter.defaultProps = {
  id: 'mobile-pane-footer',
  showBookBikeButton: true,
};

export default PaneFooter;
